import { FC } from "react"
import { useSelfEvents } from "../../../shared/user-profile/hooks"
import ProfileEventCard from "../profile_event_card"
import LocationSpinner from "@/common/ui-kit/spinner"

const MyEventList: FC = () => {
  const { isLoading, error, state } = useSelfEvents(0, 1000)
  if (isLoading)
    return (
      <div
        style={{
          minWidth: "calc(100vw - 16px)",
          textAlign: "center",
          padding: "48px 0",
        }}
      >
        <LocationSpinner />
      </div>
    )
  if (error) return <div>Error: {error.error}</div>
  return (
    <>
      {state?.events.length === 0 ? (
        <div
          style={{
            minWidth: "calc(100vw - 16px)",
            textAlign: "center",
            padding: "48px 0",
            color: "var(--Schemes-Primary)",
          }}
        >
          У вас пока нет событий
        </div>
      ) : (
        state?.events.map((event) => (
          <ProfileEventCard info={event} key={event.id} />
        ))
      )}
    </>
  )
}

export default MyEventList
